import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { LoginService } from '../../../shared/services/login.service';
import { CopyService } from '../../../shared/services/app-copy.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  providers: [
    LoginService
  ]
})
export class VerifyEmailComponent implements OnInit, OnDestroy {

  private _verifyEmailSubscription: Subscription;
  private _routeParamsSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public emailPattern = EMAIL_PATTERN;
  public showEmailLoader: Boolean = false;
  public userEmail;
  public userNotFound: Boolean = false;
  public showLoader: Boolean = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _copyService: CopyService,
  ) { }

  ngOnInit() {
    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language
      })

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          this.getCopy();
        }

      })

    // subscribe to router query string
    this._routeParamsSubscription = this._activatedRoute.queryParams
      .subscribe((params: any) => {
        if (typeof params.redirect !== 'undefined') {
          const data = { path: params.redirect, ref: params.ref };
          this._appStore.dispatch({ type: 'UPDATE_REDIRECT', payload: data });
        }
      },
        err => console.log(err));

    this._verifyEmailSubscription = this._loginService.verifyUserSubject$
      .subscribe(res => {
        this.showLoader = false;
        this._appStore.dispatch({ type: 'UPDATE_2FA_AUTH', payload: res.userData.is2FARequired });
        this._appStore.dispatch({ type: 'UPDATE_USER_STATUS', payload: res.verifyCustomerStatus });
        this._appStore.dispatch({ type: 'UPDATE_USER_HAS_ACCOUNT_DETAILS', payload: Boolean(res.userData.firstName) && Boolean(res.userData.lastName ) });

        // response codes
        // Active = 1, Inactive = 2, NotFound = 3
        if (res.verifyCustomerStatus === 1) {
          // full user
          this.showEmailLoader = false;
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL', payload: this.userEmail });
          this._appStore.dispatch({ type: 'UPDATE_USER_HAS_PASSWORD', payload: Boolean(res.userData.passwordLastResetDatetimeUTC) });

          if(res.userData.userLoginStatus === 2){
            this._router.navigate(['validate-email']);
          } else {
            if(res.userData.is2FARequired) {
              this._router.navigate(['access-account']);
            }else {
              this._router.navigate(['access-options']);
            }
          }

        } else if (res.verifyCustomerStatus === 2 || res.verifyCustomerStatus === 3) {
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL', payload: this.userEmail });
          this._appStore.dispatch({ type: 'UPDATE_USER_HAS_PASSWORD', payload: false });

          this._router.navigate(['validate-email']);
        }
      });

  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'login',
      ['loginScreen']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleSubmitEmailCheck(value, e) {
    e.preventDefault();
    this.showLoader = true;
    this.userEmail = value.email;
    this._loginService.checkEmail(this.userEmail);
  }

  ngOnDestroy() {
    this._verifyEmailSubscription.unsubscribe();
    this._routeParamsSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
  }

}
